import { grid, maxWidthContainer, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const container = css`
  ${grid}
  ${maxWidthContainer}
  grid-row-gap: 0;
`;

export const bottomOffsetImageMarginContainer = css`
  padding-top: ${spacing.lg}px;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding-top: ${spacing.xl}px;
    `,
  )};
`;

export const imageWrapper = css`
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 6;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 2 / span 5;
    `,
  )};
`;

export const content = css`
  margin: -${spacing.sm}px 0 ${spacing.base}px;
  grid-column: span 12;

  * {
    color: var(--neutral-black-base);
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 6;
      margin: 0;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 8 / span 5;
      margin: ${spacing.sm}px 0;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 8 / span 4;
    `,
  )};
`;

export const copy = css`
  display: block;
  margin: ${spacing.lg}px 0;
`;

export const heading = css`
  ${copy}
  ${responsiveText.HEADING.LG}
`;

export const cta = css`
  ${copy};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;
